import { gql } from "@apollo/client";

export const UPDATE_TEMPLATE = gql`
  mutation updateCsvExtractTemplate($templateId: String!, $title: String!, $fields: [CsvTemplateFieldInput]!) {
    updateCsvExtractTemplate(templateId: $templateId, title: $title, fields: $fields) {
      success
      message
    }
  }
`;